import React from "react";
import PinScreenLayout from "../../components/PinScreenLayout/PinScreenLayout";
import ChangePinContainer from "../../containers/ChangePinContainer/ChangePinContainer";

export function ChangePinScreen() {
    return (
        <PinScreenLayout titleKey="newPIN">
            <ChangePinContainer />
        </PinScreenLayout>
    );
}
